











import { Component, Vue } from 'vue-property-decorator';
import NavMenu from '@/components/NavMenu.vue'; // @ is an alias to /src
import DatePicker from "vue2-datepicker";
import { signIn, signOut, signedIn, authManager} from '@/utils/login';
import { User, Log } from 'oidc-client';
import * as Constants from '@/utils/constants';

@Component({
  components: {
    NavMenu,
    DatePicker,
  },
})

export default class App extends Vue {

  user: any = null;
  isAdmin: boolean = false;
  isSignedIn:boolean = false;
  //mgr = authManager;
  
  mounted() {
    Log.logger = console;
    authManager.getUser().then((user) => {
      if (user !== null) {
        console.log("User loaded:", user.profile.name);
        this.isSignedIn = true;
        this.user = user;
        this.isAdmin = user.profile.roles
                        ? user.profile.roles.indexOf(Constants.ADMIN_ROLE) > -1
                        : false;
      } else {
          console.log("Not signed in.")
      }
    }).catch((error) => {
        console.log('Error in getting user:', error.message);
    });
  }
}
